import {
  AggregationStepDashboard,
  DMSState,
  IDashboardUiState,
  RightBar,
  SideBarWindowTabs,
} from '@dashboard-store';
import { IStep } from '@dashboard/components/map-timeline/timeline.service';
import { TraceConfig } from '@dashboard/models';
import { createAction, props } from '@ngrx/store';

enum DashboardUitStateActions {
  INITIALIZE = '[DASHBOARD UI STATE] INITIALIZE',
  SET_SELECTED_VESSEL = '[DASHBOARD UI STATE] SET_SELECTED_VESSEL',
  SET_DATES = '[DASHBOARD UI STATE] SET_DATES',
  SET_TO_DATE_INTERVAL = '[DASHBOARD UI STATE] SET_TO_DATE_INTERVAL',
  SET_VESSELS = '[DASHBOARD UI STATE] SET VESSELS',
  SET_SIDEBAR_EXPAND = '[DASHBOARD UI STATE] SET_SIDEBAR_EXPAND',
  SET_SIDEBAR_HEAD_EXPAND = '[DASHBOARD UI STATE] SET TOGGLE SIDEBAR EXPAND',
  SET_VESSEL_WINDOW_EXPAND = '[DASHBOARD UI STATE] SET_VESSEL_WINDOW_EXPAND',
  SET_FOCUS_MARKER_MAP = '[DASHBOARD UI STATE] SET_FOCUS_MARKER_MAP',
  SET_TRACE_CONFIG = '[DASHBOARD UI STATE] SET_TRACE_CONFIG',
  UPDATE_TRACE_CONFIG = '[DASHBOARD UI STATE] UPDATE_TRACE_CONFIG',
  SET_ACTIVE_TRACE = '[DASHBOARD UI STATE] SET_ACTIVE_TRACE',
  SET_TRACE_OFFSET = '[DASHBOARD UI STATE] SET_TRACE_OFFSET',
  EXTEND_TRACE_CONFIG = '[DASHBOARD UI STATE] EXTEND_TRACE_CONFIG',
  ADD_NEW_TRACE_VALUE = '[DASHBOARD UI STATE] ADD_NEW_TRACE_VALUE',
  TOGGLE_VESSEL_NAME_INFO = '[DASHBOARD UI STATE] TOGGLE_VESSEL_NAME_INFO',
  SET_REALTIME_FLAG = 'SET_REALTIME_FLAG',
  SET_RIGHTBAR = 'SET_RIGHTBAR',
  SET_MAP_DMS_CLICKS = 'SET_MAP_DMS_CLICKS',
  TOGGLE_MAP_DMS = 'TOGGLE_MAP_DMS',
  SET_AGGREGATION = 'SET_AGGREGATION',
  SET_AGGREGATION_STEP = 'SET_AGGREGATION_STEP',
  SET_AGGREGATION_SIZE = 'SET_AGGREGATION_SIZE',
  SET_OFFSET_STEP = 'SET_OFFSET_STEP',
  SET_TIMEZONE = 'SET_TIMEZONE',
  SET_TOOLTIP = 'SET_TOOLTIP',
  SET_VESSEL_INFO_TAB = 'SET_VESSEL_INFO_TAB',
  TAB_IS_ACTIVE = 'TAB_IS_ACTIVE',
}
const AppInitializeAction = createAction(DashboardUitStateActions.INITIALIZE);

const TabIsActiveAction = createAction(DashboardUitStateActions.TAB_IS_ACTIVE);

const SetVesselsAction = createAction(
  DashboardUitStateActions.SET_VESSELS,
  props<{ vessels: IDashboardUiState['vessels'] }>()
);

const SetSelectedVesselAction = createAction(
  DashboardUitStateActions.SET_SELECTED_VESSEL,
  props<{ vesselId: string }>()
);

const SetSidebarHeadExpandAction = createAction(
  DashboardUitStateActions.SET_SIDEBAR_HEAD_EXPAND
);

const SetToDateIntervalAction = createAction(
  DashboardUitStateActions.SET_TO_DATE_INTERVAL,
  props<{ toDate: string; updateState: boolean }>()
);

const SetSystemDatesAction = createAction(
  DashboardUitStateActions.SET_DATES,
  props<
    | { fromDate: string; toDate?: string }
    | { fromDate?: string; toDate: string }
  >()
);

const FocusMapMarkerAction = createAction(
  DashboardUitStateActions.SET_FOCUS_MARKER_MAP,
  props<{ vesselId: string }>()
);

// const DeactivateAllKGPoisAction = createAction(
//   DashboardUitStateActions.DEACTIVATE_ALL_KG_POI
// );

const SetTraceConfigAction = createAction(
  DashboardUitStateActions.SET_TRACE_CONFIG,
  props<{ traceConfig: TraceConfig[] }>()
);

const UpdateActiveTrace = createAction(
  DashboardUitStateActions.UPDATE_TRACE_CONFIG,
  props<{ traceConfig: TraceConfig }>()
);

const SetActiveTraceAction = createAction(
  DashboardUitStateActions.SET_ACTIVE_TRACE,
  props<{ activeConfigId: number }>()
);

const SetOffsetStepAction = createAction(
  DashboardUitStateActions.SET_OFFSET_STEP,
  props<{ step: IStep }>()
);

const ToggleVesselNameInfoAction = createAction(
  DashboardUitStateActions.TOGGLE_VESSEL_NAME_INFO
);

const SetRealtimeFlagAction = createAction(
  DashboardUitStateActions.SET_REALTIME_FLAG,
  props<{ enableRealtime: boolean }>()
);

const SetRightBar = createAction(
  DashboardUitStateActions.SET_RIGHTBAR,
  props<{ selected: RightBar }>()
);

const ToggleDmsAction = createAction(DashboardUitStateActions.TOGGLE_MAP_DMS);
const SetValueDmsMapClicksAction = createAction(
  DashboardUitStateActions.SET_MAP_DMS_CLICKS,
  props<DMSState>()
);

const SetAggregation = createAction(
  DashboardUitStateActions.SET_AGGREGATION,
  props<{
    size: number | null;
    step: AggregationStepDashboard | null;
  }>()
);

const SetTimezoneAction = createAction(
  DashboardUitStateActions.SET_TIMEZONE,
  props<{ timezone: number }>()
);

const SetTooltipAction = createAction(
  DashboardUitStateActions.SET_TOOLTIP,
  props<{ value: string }>()
);

type TErrorSlices = keyof IDashboardUiState['errors']['charts'];

const SetChartErrorMessage = createAction(
  '[DASHBOARD UI STATE] SET_ERROR',
  props<{ key: TErrorSlices; errorMsg: string | null }>()
);
const ClearChartErrorMessage = createAction(
  '[DASHBOARD UI STATE] CLEAR_ERROR',
  props<{ key: TErrorSlices }>()
);
export {
  DashboardUitStateActions,
  SetSelectedVesselAction,
  SetVesselsAction,
  SetSidebarHeadExpandAction,
  SetTraceConfigAction,
  SetActiveTraceAction,
  UpdateActiveTrace,
  FocusMapMarkerAction,
  ToggleVesselNameInfoAction,
  SetRealtimeFlagAction,
  SetRightBar,
  AppInitializeAction,
  ToggleDmsAction,
  SetValueDmsMapClicksAction,
  SetSystemDatesAction,
  SetToDateIntervalAction,
  SetAggregation,
  SetOffsetStepAction,
  SetTimezoneAction,
  SetTooltipAction,
  TabIsActiveAction,
  SetChartErrorMessage,
  ClearChartErrorMessage,
};
